// extracted by mini-css-extract-plugin
export var menuIcon = "_rn-0";
export var menuIconInline = "_rn-1";